import moment from 'moment';
import { createReducer } from '../../../../utils/reducerUtil';
import { ACTION_STATUS } from '../../../../utils/ActionStatus';
import {
    RULE_REPORT_INPUT_CHANGE,
    START_LOAD_RULE_REPORT,
    LOAD_RULE_REPORT_SUCCESS,
    LOAD_RULE_REPORT_FAILURE,
    INIT_LOAD_RULE_REPORT_ACTION_STATUS,
    START_GENERATE_RULE_REPORT,
    GENERATE_RULE_REPORT_SUCCESS,
    GENERATE_RULE_REPORT_FAILURE,
    INIT_GENERATE_RULE_REPORT_ACTION_STATUS,
    OPEN_RESOLVE_RULE_REPORT_MODAL,
    CLOSE_RESOLVE_RULE_REPORT_MODAL,
    RESOLVE_RULE_REPORT_CHANGE_INPUT,
    START_UPDATE_RULE_REPORT,
    UPDATE_RULE_REPORT_SUCCESS,
    UPDATE_RULE_REPORT_FAILURE,
    INIT_UPDATE_RULE_REPORT_ACTION_STATUS,
    SELECT_RULE_REPORT,
    START_STAT_REPORT,
    STAT_REPORT_SUCCESS,
    STAT_REPORT_FAILURE,
    INIT_STAT_REPORT_ACTION_STATUS,
} from './ruleReportConstants';

const initialState = {
    ruleReportQueryFields: {
        date: moment(),
        ruleCategory: 'All',
        fund: 'All',
        showAll: false,
    },
    loadRuleReportActionStatus: ACTION_STATUS.READY,
    generateRuleReportActionStatus: ACTION_STATUS.READY,
    ruleReportActionResp: undefined,
    selectedRuleReportArray: [],
    resolveModal: {
        isOpened: false,
        fields: {
            id: null,
            remarks: '',
            ruleReportRecord: null,
            selectedRecords: [],
        },
    },
    updateRuleReportActionStatus: ACTION_STATUS.READY,
    updateRuleReportActionResp: undefined,
    statReportActionStatus: ACTION_STATUS.READY,
    statReportActionResp: undefined,
};

function inputChange(state, { name, value }) {
    return { ...state, ruleReportQueryFields: { ...state.ruleReportQueryFields, [name]: value } };
}
function selectRuleReport(state, payload) {
    return { ...state, selectedRuleReportArray: payload || [] };
}
function startLoad(state) { return { ...state, loadRuleReportActionStatus: ACTION_STATUS.LOGINING }; }
function loadSuccess(state, payload) { return { ...state, loadRuleReportActionStatus: ACTION_STATUS.SUCCESS, ruleReportActionResp: payload }; }
function loadFailure(state, payload) { return { ...state, loadRuleReportActionStatus: ACTION_STATUS.ERROR, ruleReportActionResp: payload }; }
function initLoad(state) { return { ...state, loadRuleReportActionStatus: ACTION_STATUS.READY }; }
function startGenerate(state) { return { ...state, generateRuleReportActionStatus: ACTION_STATUS.LOGINING }; }
function generateSuccess(state, payload) { return { ...state, generateRuleReportActionStatus: ACTION_STATUS.SUCCESS, generateRuleReportActionResp: payload }; }
function generateFailure(state, payload) { return { ...state, generateRuleReportActionStatus: ACTION_STATUS.ERROR, generateRuleReportActionResp: payload }; }
function initGenerate(state) { return { ...state, generateRuleReportActionStatus: ACTION_STATUS.READY }; }

function openResolveModal(state, payload) {
    const records = Array.isArray(payload) ? payload : (payload ? [payload] : []);
    const firstRecord = records[0] || null;
    return {
        ...state,
        resolveModal: {
            isOpened: true,
            fields: {
                id: firstRecord ? firstRecord.id : null,
                remarks: firstRecord ? firstRecord.remarks || '' : '',
                ruleReportRecord: firstRecord,
                selectedRecords: records,
            },
        },
    };
}

function closeResolveModal(state) {
    return {
        ...state,
        resolveModal: {
            isOpened: false,
            fields: {
                id: null,
                remarks: '',
                ruleReportRecord: null,
                selectedRecords: [],
            },
        },
    };
}

function resolveChangeInput(state, { name, value }) {
    return {
        ...state,
        resolveModal: {
            ...state.resolveModal,
            fields: {
                ...state.resolveModal.fields,
                [name]: value,
            },
        },
    };
}

function startUpdate(state) { return { ...state, updateRuleReportActionStatus: ACTION_STATUS.LOGINING }; }
function updateSuccess(state, payload) { return { ...state, updateRuleReportActionStatus: ACTION_STATUS.SUCCESS, updateRuleReportActionResp: payload }; }
function updateFailure(state, payload) { return { ...state, updateRuleReportActionStatus: ACTION_STATUS.ERROR, updateRuleReportActionResp: payload }; }
function initUpdate(state) { return { ...state, updateRuleReportActionStatus: ACTION_STATUS.READY }; }
function startStatReport(state) { return { ...state, statReportActionStatus: ACTION_STATUS.LOGINING }; }
function statReportSuccess(state, payload) { return { ...state, statReportActionStatus: ACTION_STATUS.SUCCESS, statReportActionResp: payload }; }
function statReportFailure(state, payload) { return { ...state, statReportActionStatus: ACTION_STATUS.ERROR, statReportActionResp: payload }; }
function initStatReport(state) { return { ...state, statReportActionStatus: ACTION_STATUS.READY }; }

export default createReducer(initialState, {
    [RULE_REPORT_INPUT_CHANGE]: inputChange,
    [SELECT_RULE_REPORT]: selectRuleReport,
    [START_LOAD_RULE_REPORT]: startLoad,
    [LOAD_RULE_REPORT_SUCCESS]: loadSuccess,
    [LOAD_RULE_REPORT_FAILURE]: loadFailure,
    [INIT_LOAD_RULE_REPORT_ACTION_STATUS]: initLoad,
    [START_GENERATE_RULE_REPORT]: startGenerate,
    [GENERATE_RULE_REPORT_SUCCESS]: generateSuccess,
    [GENERATE_RULE_REPORT_FAILURE]: generateFailure,
    [INIT_GENERATE_RULE_REPORT_ACTION_STATUS]: initGenerate,
    [OPEN_RESOLVE_RULE_REPORT_MODAL]: openResolveModal,
    [CLOSE_RESOLVE_RULE_REPORT_MODAL]: closeResolveModal,
    [RESOLVE_RULE_REPORT_CHANGE_INPUT]: resolveChangeInput,
    [START_UPDATE_RULE_REPORT]: startUpdate,
    [UPDATE_RULE_REPORT_SUCCESS]: updateSuccess,
    [UPDATE_RULE_REPORT_FAILURE]: updateFailure,
    [INIT_UPDATE_RULE_REPORT_ACTION_STATUS]: initUpdate,
    [START_STAT_REPORT]: startStatReport,
    [STAT_REPORT_SUCCESS]: statReportSuccess,
    [STAT_REPORT_FAILURE]: statReportFailure,
    [INIT_STAT_REPORT_ACTION_STATUS]: initStatReport,
});

